/**
 * FTUE clock (project100 D-015) — page KPI is time-to-entry: how long from the
 * landing page mounting until the guest submits their company URL. The mount
 * mark is set by LandingPage; the fallback is module load time so a reading is
 * always available.
 */

let landingMountAt = Date.now();

export function markLandingMount(): void {
  landingMountAt = Date.now();
}

export function msSinceLandingMount(): number {
  return Date.now() - landingMountAt;
}
